import React from 'react';
import ContentPage from './pages/ContentPage';
import CheckpointDirectionsPage from './pages/CheckpointDirectionsPage';
import QuizQuestionPage from './pages/QuizQuestionPage';
import QuizResultsPage from './pages/QuizResultsPage';
import InteractiveGridPage from './pages/InteractiveGridPage';
import VirtualClassPage from './pages/VirtualClassPage';
import SeePage from './pages/SeePage';
import HearPage from './pages/HearPage';
import DoPage from './pages/DoPage';
import ArcQuizPage from './pages/ArcQuizPage';
import VoiceQuestionPage from './pages/VoiceQuestionPage';
import IntroductionAudio from './IntroductionAudio';

const PageRenderer = ({ page, lesson, quizAnswers, quizResults, quizAnswerResults = {}, checkpointStatus = {}, onAnswer, onNext, onRetake, onCompletionChange, triggerQuizFeedback = false, onFeedbackComplete }) => {
 
  const renderIntroductionAudio = () => {
    if (!page.introductionAudio || 
        page.type === 'virtual-class' || 
        page.type === 'virtual-class-see' || 
        page.type === 'virtual-class-hear' || 
        page.type === 'virtual-class-do' ||
        page.type === 'arc-quiz' || 
        page.type === 'voice-question') return null;
    return (
      <div className="mb-6">
        <IntroductionAudio
          audio={page.introductionAudio}
          autoPlay={page.introductionAudio.autoPlay}
        />
      </div>
    );
  };

  const renderPageContent = () => {
    switch (page.type) {
      case 'content':
        return <ContentPage page={page} />;
      
      case 'checkpoint-directions':
        return <CheckpointDirectionsPage page={page} lesson={lesson} />;
      
      case 'quiz-question':
        const checkpointStatusForPage = checkpointStatus[page.checkpointId] || {};
        const isCheckpointPassed = checkpointStatusForPage.passed === true;
        const canAttempt = checkpointStatusForPage.canAttempt !== false;
        
        return (
          <QuizQuestionPage
            page={page}
            lesson={lesson}
            selectedAnswer={quizAnswers[page.checkpointId]?.[page.id]}
            answerIsCorrect={quizAnswerResults[page.checkpointId]?.[page.id]}
            isCheckpointPassed={isCheckpointPassed}
            canAttempt={canAttempt}
            onAnswer={(answer) => onAnswer(page.id, page.checkpointId, answer)}
            onNext={() => {
              if (onFeedbackComplete) onFeedbackComplete();
              onNext();
            }}
            triggerFeedback={triggerQuizFeedback}
          />
        );
      
      case 'quiz-results':
        return (
          <QuizResultsPage
            page={page}
            lesson={lesson}
            quizAnswers={quizAnswers[page.checkpointId] || {}}
            quizResults={quizResults}
            checkpoint={lesson.checkpoints.find(c => c.id === page.checkpointId)}
            onNext={onNext}
            onRetake={onRetake ? () => onRetake(page.checkpointId) : undefined}
          />
        );
      
      case 'interactive-grid':
        return <InteractiveGridPage page={page} onNext={onNext} />;
      
      case 'arc-quiz':
        return <ArcQuizPage page={page} onNext={onNext} onCompletionChange={onCompletionChange} />;
      
      case 'virtual-class':
        return <VirtualClassPage page={page} lesson={lesson} onNext={onNext} onCompletionChange={onCompletionChange} />;
      
      case 'virtual-class-see':
        return <SeePage page={page} lesson={lesson} onNext={onNext} onCompletionChange={onCompletionChange} />;
      
      case 'virtual-class-hear':
        return <HearPage page={page} lesson={lesson} onNext={onNext} onCompletionChange={onCompletionChange} />;
      
      case 'virtual-class-do':
        return <DoPage page={page} lesson={lesson} onNext={onNext} onCompletionChange={onCompletionChange} />;
      
      case 'voice-question':
        return <VoiceQuestionPage page={page} onNext={onNext} />;
      
      default:
        return (
          <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
            <p className="text-yellow-800">Unknown page type: {page.type}</p>
          </div>
        );
    }
  };

  return (
    <div>
      {renderIntroductionAudio()}
      {renderPageContent()}
    </div>
  );
};

export default PageRenderer;

